import { HttpInterceptorFn } from "@angular/common/http";
import { inject } from "@angular/core";
import { firstValueFrom, tap } from "rxjs";
import { AuthService } from "../services/auth.service";
import { BrowserService } from "../services/browser.service";
import { StoreChangesService } from "../services/store-changes.service";
import { CrispChatService } from "../services/crisp-chat.service";
import { Router } from "@angular/router";
import { LanguageService } from "projects/shop/src/app/+shared/services/language.service";


export const SessionExpiredInterceptor: HttpInterceptorFn = (request, next) => {
  const _authService = inject(AuthService);
  const _browserService = inject(BrowserService);
  const _storeChangesService = inject(StoreChangesService);
  const _crispChatService = inject(CrispChatService);
  const _router = inject(Router);
  const _languageService = inject(LanguageService);

  return next(request).pipe(
    tap(
      res => { },
      async error => {
        if (error.status == 401 && error.error.message.toLowerCase().includes('session expired')) {
          if (!request.url.includes('validate')) {
            _crispChatService.resetSession();
            _crispChatService.crispChat.next('reset');
            if (_browserService.getSessionStorage()) {
              sessionStorage.removeItem('token');
              sessionStorage.removeItem('userExist');
            }
            _storeChangesService.setUser(null);
            _storeChangesService.setLoginSecret(null!);
            _authService.updateUserShop(null);
            let lang = await firstValueFrom(_languageService.arabic);
            _router.navigate([`/${lang ? 'ar' : 'en'}/auth/signin`]);
          }
        }
      }
    )
  );
}